module.exports = __webpack_public_path__ + "img/download-alt.033c8443.svg";